<script>
import {useStore} from "vuex";
import {ref} from "vue";
import Swal from "sweetalert2";
import router from "@/router";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import NavbarPage from "@/components/assetComponents/NavbarPage.vue";

export default {
  name: "MyProfile",
  components: {NavbarPage, LoadingPage},
  setup() {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0

    let store = useStore()

    let my_prof = ref(store.state.my_profile)

    let states = ref([])
    let cities = ref([])

    let loading = ref(false)

    async function get_country() {
      loading.value = true

      await FreeWorld.Heisenberg({action: 'show'}, 'user_edit', true).then((result) => {

        loading.value = false
        my_prof.value = result.data

      }).catch((res) => {
        Swals.Catch(res, get_country )
      })

      await FreeWorld.Heisenberg({}, 'user/city').then((res) => {

        states.value = res.data.results
        chang_city()

      }).catch((result) => {
        loading.value = false
        Swals.Catch(result, get_country)
      })
    }

    get_country()

    function set_user() {

      if (my_prof.value.full_name.trim().length == 0) {
        Swal.fire({
          text: "لطفا نام و نام خانوادگی خود را وارد کنید!",
          icon: "warning",
          showCancelButton: false,
          confirmButtonText: "متوجه شدم",
          showClass: {
            popup: 'animate__animated animate__bounceInDown'
          },
          hideClass: {
            popup: 'animate__animated animate__bounceOutUp'
          }
        })
      } else {

        let data = {
          action: 'edite',
          full_name: my_prof.value.full_name,
          state_id: my_prof.value.state_id,
          city_id: my_prof.value.city_id,
          phone: my_prof.value.phone
        }

        loading.value = true
        FreeWorld.Heisenberg(data, 'user_edit', true).then((result) => {

          loading.value = false
          let res = result.data
          if (res.event == "update ok") {

            store.commit('set_my_profile', my_prof.value)
            Swal.fire({
              position: "center",
              icon: "success",
              title: "پروفایل شما با موفقیت ویرایش شد",
              showConfirmButton: true,
              confirmButtonText: 'متوجه شدم',
              allowOutsideClick: false,
              showClass: {
                popup: 'animate__animated animate__bounceInDown'
              },
              hideClass: {
                popup: 'animate__animated animate__bounceOutUp'
              }
            }).then(() => {
              router.push("HomePage")
            })

          } else {

            Swal.fire({
              position: "center",
              icon: "error",
              title: "متاسفانه پروفایل شما ویرایش نشد",
              showConfirmButton: true,
              confirmButtonText: 'متوجه شدم',
              allowOutsideClick: false,
              showClass: {
                popup: 'animate__animated animate__bounceInDown'
              },
              hideClass: {
                popup: 'animate__animated animate__bounceOutUp'
              }
            })

          }

        }).catch((result) => {
          loading.value = false
          Swals.Catch(result, set_user)
        })
      }
    }

    function chang_city() {
      if (my_prof.value.state_id != -1) {
        states.value.forEach((item) => {
          if (my_prof.value.state_id == item.id) {
            cities.value = item.city
          }
        })
      }
    }

    function select_city() {

      if (my_prof.value.state_id != -1) {
        states.value.forEach((item) => {
          if (my_prof.value.state_id == item.id) {
            cities.value = item.city
            my_prof.value.city_id = item.city[0].id
          }
        })
      } else {
        cities.value = []
        my_prof.value.city_id = -1
      }

    }

    return {

      my_prof,
      select_city,
      states,
      cities,
      set_user,
      loading,

    }
  }
}
</script>

<template>

  <LoadingPage v-if="loading"></LoadingPage>
  <div dir="ltr" id="main" :class="loading ? 'activeClass' : '' " class="bg-main">

    <div class="div-top-arrow bg-color d-flex align-items-center">
      <div class="d-flex align-items-center">
        <p class="m-0">
          پروفایل من
        </p>
        <div onclick="history.back()" class="">
          <img class="svg-arrow" src="../assets/img/back.svg" alt="">
        </div>
      </div>
    </div>
    <br>
    <br>
    <br>
    <br>

    <div class="p-body mt-2">
      <div class="w-100">
        <div class="d-flex justify-content-end mb-2 p-body">
          <img style="width: 20px" src="../assets/img/editing.svg" alt="">
          <p class="m-0 font-4">
            نام و نام خانوادگی
          </p>
        </div>
        <input v-model="my_prof.full_name" class="p-4 rounded-4 shadow bg-white border-costom w-100 text-center font-4"
               type="text">
      </div>

      <br>

      <div class="w-100">
        <div class="d-flex justify-content-end mb-2 p-body">
          <p class="m-0 font-4">
            شماره همراه
          </p>
        </div>
        <div class="p-4 rounded-4 border-costom shadow w-100 text-center font-4">{{ my_prof.phone }}</div>
      </div>

      <br>

      <div class="w-100">
        <div class="d-flex justify-content-end mb-2 p-body">
          <img style="width: 20px" src="../assets/img/editing.svg" alt="">
          <p class="m-0 font-4">
            استان
          </p>
        </div>
        <!--        <input class="p-4 rounded-4 border-costom w-100 text-center font-4" type="text">-->
        <select @change="select_city" v-model="my_prof.state_id"
                class="p-4 rounded-4 border-costom shadow w-100 text-center font-4 bg-white">
          <option v-for="item in states" :key="item.id" :value="item.id">{{ item.name }}</option>
        </select>

      </div>

      <br>

      <div class="w-100">
        <div class="d-flex justify-content-end mb-2 p-body">
          <img style="width: 20px" src="../assets/img/editing.svg" alt="">
          <p class="m-0 font-4">
            شهر
          </p>
        </div>

        <select v-model="my_prof.city_id" class="p-4 rounded-4 shadow border-costom w-100 text-center font-4 bg-white">
          <option v-for="item in cities" :key="item.id" :value="item.id">{{ item.name }}</option>
        </select>

      </div>

      <br>

      <div class="w-100">
        <div class="d-flex justify-content-end mb-2 p-body">
          <p class="m-0 font-4">
            کد معرفی شما
          </p>
        </div>
        <div class="p-4 rounded-4 border-costom shadow w-100 text-center font-4">{{
            my_prof.user_code ?? 'تعریف نشده'
          }}
        </div>
      </div>
    </div>

    <br>
    <br>

    <div class="w-100 d-flex justify-content-center">
      <v-btn @click="set_user" class="w-50 h-100 p-3 font-4 rounded-3 bg-color text-white border-costom">
        ثبت
      </v-btn>
    </div>

  </div>

  <div id="web" :class="loading ? 'activeClass' : '' " class="bg-main">

    <NavbarPage></NavbarPage>

    <div style="background-color: white" class="rounded-4 font-bold font-color p-3 mb-5 w-75 ma-auto">کاربری</div>
    <div class="animate__animated animate__fadeIn p-body mt-2 w-75 ma-auto bg-white rounded-4 p-5">

      <div class="w-100">
        <div class="d-flex mb-2 p-body">
          <p class="m-0 font-4">
            نام و نام خانوادگی
          </p>
          <img style="width: 20px" src="../assets/img/editing.svg" alt="">
        </div>
        <input v-model="my_prof.full_name" class="p-3 shadow rounded-4 bg-white border-costom w-100 text-center font-4"
               type="text">
      </div>

      <br>

      <div class="w-100">
        <div class="d-flex mb-2 p-body">
          <p class="m-0 font-4">
            شماره همراه
          </p>
        </div>
        <div class="p-3 shadow rounded-4 border-costom w-100 text-center font-4">{{ my_prof.phone }}</div>
      </div>

      <br>

      <div class="w-100">
        <div class="d-flex mb-2 p-body">
          <p class="m-0 font-4">
            استان
          </p>
          <img style="width: 20px" src="../assets/img/editing.svg" alt="">
        </div>
        <!--        <input class="p-4 rounded-4 border-costom w-100 text-center font-4" type="text">-->
        <select @change="select_city" v-model="my_prof.state_id"
                class="p-3 shadow rounded-4 border-costom w-100 text-center font-4 bg-white">
          <option class="font-5" v-for="item in states" :key="item.id" :value="item.id">{{ item.name }}</option>
        </select>

      </div>

      <br>

      <div class="w-100">
        <div class="d-flex mb-2 p-body">
          <p class="m-0 font-4">
            شهر
          </p>
          <img style="width: 20px" src="../assets/img/editing.svg" alt="">
        </div>

        <select v-model="my_prof.city_id" class="p-3 shadow rounded-4 border-costom w-100 text-center font-4 bg-white">
          <option class="font-5" v-for="item in cities" :key="item.id" :value="item.id">{{ item.name }}</option>
        </select>

      </div>

      <br>

      <div class="w-100">
        <div class="d-flex mb-2 p-body">
          <p class="m-0 font-4">
            کد معرفی شما
          </p>
        </div>
        <div class="p-4 rounded-4 border-costom shadow w-100 text-center font-4">{{
            my_prof.user_code ?? 'تعریف نشده'
          }}
        </div>
      </div>

      <br>
      <br>
      <br>

      <div class="w-100 d-flex justify-content-center">
        <v-btn @click="set_user" class="w-50 h-100 p-3 font-4 rounded-3 bg-color text-white border-costom">
          ثبت
        </v-btn>
      </div>

    </div>

  </div>

</template>

<style scoped>

</style>